/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseSourceDto
 */
export interface CaseSourceDto {
    /**
     * 
     * @type {boolean}
     * @memberof CaseSourceDto
     */
    primarySource?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    sourceTechnology?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    sourceTechnologyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    sourceTechnologyDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    externalSourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    sourceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    correlationId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseSourceDto
     */
    sourceMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CaseSourceDto
     */
    isPrimarySource?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CaseSourceDto
     */
    lastSyncTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceDto
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseSourceDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseSourceDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the CaseSourceDto interface.
 */
export function instanceOfCaseSourceDto(value: object): value is CaseSourceDto {
    return true;
}

export function CaseSourceDtoFromJSON(json: any): CaseSourceDto {
    return CaseSourceDtoFromJSONTyped(json, false);
}

export function CaseSourceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseSourceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'primarySource': json['primarySource'] == null ? undefined : json['primarySource'],
        'id': json['id'] == null ? undefined : json['id'],
        'sourceTechnology': json['sourceTechnology'] == null ? undefined : json['sourceTechnology'],
        'sourceTechnologyCode': json['sourceTechnologyCode'] == null ? undefined : json['sourceTechnologyCode'],
        'sourceTechnologyDisplayName': json['sourceTechnologyDisplayName'] == null ? undefined : json['sourceTechnologyDisplayName'],
        'externalSourceId': json['externalSourceId'] == null ? undefined : json['externalSourceId'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'sourceMetadata': json['sourceMetadata'] == null ? undefined : json['sourceMetadata'],
        'isPrimarySource': json['isPrimarySource'] == null ? undefined : json['isPrimarySource'],
        'lastSyncTime': json['lastSyncTime'] == null ? undefined : (new Date(json['lastSyncTime'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function CaseSourceDtoToJSON(json: any): CaseSourceDto {
    return CaseSourceDtoToJSONTyped(json, false);
}

export function CaseSourceDtoToJSONTyped(value?: CaseSourceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primarySource': value['primarySource'],
        'id': value['id'],
        'sourceTechnology': value['sourceTechnology'],
        'sourceTechnologyCode': value['sourceTechnologyCode'],
        'sourceTechnologyDisplayName': value['sourceTechnologyDisplayName'],
        'externalSourceId': value['externalSourceId'],
        'sourceName': value['sourceName'],
        'correlationId': value['correlationId'],
        'sourceMetadata': value['sourceMetadata'],
        'isPrimarySource': value['isPrimarySource'],
        'lastSyncTime': value['lastSyncTime'] == null ? undefined : ((value['lastSyncTime']).toISOString()),
        'tenantId': value['tenantId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

